export const EVENTS = {
  COVERAGE_POOLS: {
    WITHDRAWAL_INITIATED: "WithdrawalInitiated",
    WITHDRAWAL_COMPLETED: "WithdrawalCompleted",
  },
}
